import {
  SettingParamConfigurationKeyEnum,
  SettingParamDomainEnum,
  SettingParamValueDataTypeEnum,
} from "../api/generated/v1.0/app";

export const SETTINGS_KEYS: Record<
  SettingParamConfigurationKeyEnum,
  SettingKeys
> = {
  company_name: "companyName",
  company_details: "companyDetails",
  invoice_limit_in_month: "invoiceLimit",
  user_panel_manual_last_updated: "userManual",
  admin_panel_manual_last_updated: "adminManual",
  import_publication: "importPublication",
  should_mask_bank_info: "shouldMaskBankInfo",
  ip_access_restriction: "ipAccessRestriction"
};

export const SETTINGS_DOMAINS: Record<SettingKeys, SettingParamDomainEnum> = {
  companyName: "COMPANY",
  companyDetails: "COMPANY",
  invoiceLimit: "INVOICE",
  userManual: "MANUAL",
  adminManual: "MANUAL",
  importPublication: "INVOICE",
  shouldMaskBankInfo: "COMPANY",
  ipAccessRestriction: "COMPANY"
};

// Type
export type SettingKeys =
  | "companyName"
  | "companyDetails"
  | "invoiceLimit"
  | "userManual"
  | "adminManual"
  | "importPublication"
  | "shouldMaskBankInfo"
  | "ipAccessRestriction";

export type SettingValues = {
  id: number;
  value: string | boolean;
  lastModifiedAt: number;
  valueDataType: SettingParamValueDataTypeEnum;
  domain: SettingParamDomainEnum;
};

export type Settings = Record<SettingKeys, SettingValues>;
